import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

function HeaderComponent () {

  let [isFixed, setIsFixed] = useState(false);


  const mobileMenu = () => {
    document
      .querySelector(".header__bars")
      .addEventListener("click", function (e) {
        document.querySelector(".header .header__nav").classList.toggle("shown");
        document.querySelector(".header .header__nav").classList.toggle("shownMenu");
        e.preventDefault();
      });

    //Close Mobile Menu
    let sideMenuCloser = document.querySelectorAll(
      ".header .header__nav span"
    );

    sideMenuCloser.forEach((sideMenuCloserBtn) => {
      sideMenuCloserBtn.addEventListener("click", function (e) {
        document.querySelector(".header .header__nav").classList.remove("shown");
        document.querySelector(".header .header__nav").classList.remove("shownMenu");
        e.preventDefault();
      });
    });
  };

  useEffect(() => {
    mobileMenu();
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      // Adjust the scroll threshold as needed
      const scrollThreshold = 100;

      if (scrollPosition > scrollThreshold) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      mobileMenu();
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

 return <header className={`header header-1 ${isFixed ? 'fixed' : ''}`}>
 <div className="container">
   <div className="header__wrapper">
     <div className="header__logo">
       <Link to="/">
         <img src={require('../../assets/images/galaxy-logo-small.png')} alt="logo" width={50}/>
       </Link>
     </div>
     <div className="header__nav">
       <ul className="header__nav-primary">
         <li><Link to="/"><i class="fad fa-home-alt"></i></Link></li>
         <li className="nav__dropdown dropdown-wrapper" id="menu-1">
           <Link to="/" className="nav__dropdown-info dropdown-info">
             Home
           </Link>
           {/* <ul className="nav__dropdown-box dropdown-box">
             <li><a href="/">Home 1</a></li>
             <li><a href="index2.html">Home 2</a></li>
           </ul> */}
         </li>
         <li><a href="#video">Video</a></li>
         <li><a href="#feature">Features</a></li>
         <li><a href="#feedback">Feedbacks</a></li>
         <li><a href="#faq">FAQs</a></li>
         <li><a href="#pricing">Pricing</a></li>
         <li><a href="#preview">Preview</a></li>
         <li className="nav__dropdown dropdown-wrapper" id="menu-2">
           <a href="#" className="nav__dropdown-info dropdown-info">
             Pages
           </a>
           <ul className="nav__dropdown-box dropdown-box">
             <li><Link to="/blog">Blog</Link></li>
             <li><Link to="/blog-single">Blog single</Link></li>
           </ul>
         </li>
       </ul>
       <span><i className="fas fa-times" /></span>
     </div>
     <div className="header__bars">
       <div className="header__bars-bar header__bars-bar-1" />
       <div className="header__bars-bar header__bars-bar-2" />
       <div className="header__bars-bar header__bars-bar-3" />
     </div>
   </div>
 </div>
</header>
}

export default HeaderComponent;